import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateTeacherType, TeacherType } from "../../../types/Teacher";

const initialStateTeacher : TeacherType = {
    startDate: "",
    idDepartament: "",
    isLinked: true
}
const initialState: CreateTeacherType = {
    user: {
        id: undefined,
        name: "",
        userName: "",
        email: "",
        bi: "",
        nuit: "",
        phoneNumber: "",
        dateOfBirth: "",
        gender: "M",
        role: undefined,
        password: undefined, 
        isForeign: false
    },
    teacher: {
        id: undefined,
        status: undefined,
        enrollmentDate: undefined,
        teacherUniversalCode: undefined,
        endDate: undefined,
        idUser: undefined,
        idTeacherSupervisor: undefined,
        idDepartament: "",
        startDate: "",
        isLinked: true
    },
    documents: [],
    idFaculty: "",
    idDepartament: "",
    teacherDepartaments: []
};
export const teacherSlice = createSlice({
    name: "teacherForm",
    initialState,
    reducers: {
        setUpdateTeacherData: (
            state, action: PayloadAction<CreateTeacherType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateTeachertData: (
            state,
        ) => {
            return initialState
        },
        setTeacherData: (
            state, action: PayloadAction<TeacherType>
          ) => {
            state.teacher = action.payload;
          },
        resetTeacherData: (state) => {
            state.teacher = initialStateTeacher
        }
    }
});
export const { setUpdateTeacherData,resetUpdateTeachertData, setTeacherData, resetTeacherData } = teacherSlice.actions;
export default teacherSlice.reducer;